import { Plus } from 'lucide-react';

function ButtonAddSequenceNiveau({ onClick }) {
  return (
    <div className="relative flex justify-center mb-12 pt-8">
      {/* Bouton circulaire d'ajout */}
      <button
        onClick={onClick}
        className="group relative w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center shadow-xl shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-500/40 hover:scale-110 transition-all duration-300 border-4 border-white"
        title="Ajouter une séquence"
      >
        {/* Icône + */}
        <Plus className="w-8 h-8 text-white group-hover:rotate-90 transition-transform duration-300" />

        {/* Effet de pulsation */}
        <div className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-20" />

        {/* Cercle lumineux au hover */}
        <div className="absolute -inset-2 rounded-full bg-gradient-to-br from-emerald-400/30 to-teal-500/30 opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-300" />
      </button>

      {/* Tooltip au hover */}
      <div className="absolute top-full mt-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="bg-slate-800 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap shadow-lg">
          Ajouter une séquence
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-800 rotate-45" />
        </div>
      </div>
    </div>
  );
}

export default ButtonAddSequenceNiveau;
